<template>
  <div class="dv-scroll-board" :ref="ref">
    <div class="header" v-if="mergedConfig">
      <div
        class="header-item"
        v-for="(headerItem, i) in mergedConfig.header"
        :key="headerItem + i"
        :style="
          `
          height: ${mergedConfig.headerHeight}px;
          line-height: ${mergedConfig.headerHeight}px;
          width: ${mergedConfig.columnWidth[i]}px;
          padding-left:${mergedConfig.columnPaddingLeft[i]}px;
          font-size: ${mergedConfig.headerFontSize}px;
        `
        "
        :align="aligns[i]"
      >
        {{ headerItem }}
      </div>
    </div>

    <div
      v-if="mergedConfig"
      class="rows"
      :style="{
        height: `${height -
          (header.length ? mergedConfig.headerHeight : 0) -
          mergedConfig.columnMarginTop}px`,
        marginTop: `${mergedConfig.columnMarginTop}px`,
        marginRight: `${mergedConfig.columnMarginRight}px`
      }"
    >
      <div
        class="row-item"
        :class="ri % 2 !== 0 ? 'card-bg-2' : ''"
        v-for="(row, ri) in rows"
        :key="row.toString() + row.scroll"
        :style="
          `
          height: 20px;
          line-height: 20px;
          fontSize: ${mergedConfig.columnFontSize}px;
        `
        "
      >
        <div
          class="ceil"
          v-for="(ceil, ci) in row.ceils"
          :key="ceil + ri + ci"
          :style="
            `
          width: ${mergedConfig.columnWidth[ci]}px;
          padding-left:${mergedConfig.columnPaddingLeft[ci]}px;
        `
          "
          :align="aligns[ci]"
        >
          <countTo
            v-if="typeof(ceil) == 'number'"
            :startVal="0"
            :endVal="ceil"
            :duration="2000"
            :key="componentKey"
          ></countTo>
          <span v-else>
            {{ ceil }}
          </span>
          <!-- {{ ceil }} -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import autoResize from '@/utils/auto-resize';
import countTo from 'vue-count-to';

export default {
  mixins: [autoResize],
  components: {
    countTo,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey: 0,
      ref: 'scroll-board',
      defaultConfig: {
        /**
         * @description Board header
         * @type {Array<String>}
         * @default header = []
         * @example header = ['column1', 'column2', 'column3']
         */
        header: [],
        /**
         * @description Board data
         * @type {Array<Array>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Header background color
         * @type {String}
         * @default headerBGC = '#00BAFF'
         */
        headerBGC: '#00BAFF',
        headerFontSize: 15, // 表头文字大小
        columnFontSize: 14, // 列文字大小
        columnMarginTop: 0, // 表格与表头间距
        columnMarginRight: 0, // 表格与右侧间距
        /**
         * @description Odd row background color
         * @type {String}
         * @default oddRowBGC = '#003B51'
         */
        oddRowBGC: '#003B51',
        /**
         * @description Even row background color
         * @type {String}
         * @default evenRowBGC = '#003B51'
         */
        evenRowBGC: '#0A2732',
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 0,
        /**
         * @description Header height
         * @type {Number}
         * @default headerHeight = 35
         */
        headerHeight: 35,
        /**
         * @description Column width
         * @type {Array<Number>}
         * @default columnWidth = []
         */
        columnWidth: [],
        columnIndex: [],
        columnStyle: [],
        columnPaddingLeft: [],
        /**
         * @description Column align
         * @type {Array<String>}
         * @default align = []
         * @example align = ['left', 'center', 'right']
         */
        align: [],
        /**
         * @description Show index
         * @type {Boolean}
         * @default index = false
         */
        index: false,
        /**
         * @description index Header
         * @type {String}
         * @default indexHeader = '#'
         */
        indexHeader: '#',
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        autoPlay: true,
      },
      mergedConfig: null,
      header: [],
      rowsData: [],
      rows: [],
      widths: [],
      heights: [],
      avgHeight: 0,
      aligns: [],
      animationIndex: 0,
      animationHandler: '',
      updater: 0,
    };
  },
  watch: {
    config() {
      this.calcData();
    },
    isRefresh() {
      if (this.isRefresh) {
        this.forceRerender();
      }
    },
  },
  unmounted() {
    const { stopAnimation } = this;
    stopAnimation();
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    afterAutoResizeMixinInit() {
      this.calcData();
    },
    // onResize() {
    //   if (!this.mergedConfig) return;
    //   console.log('merge2s', this.mergedConfig);

    //   this.calcWidths();
    //   // this.calcHeights();
    // },
    mergeConfig() {
      this.mergedConfig = { ...this.defaultConfig, ...this.config };
    },
    calcData() {
      this.mergeConfig();
      this.calcHeaderData();
      this.calcRowsData();
      // this.calcWidths();
      // this.calcHeights();
      this.calcAligns();
      if (this.mergedConfig.autoPlay) {
        this.animation(true);
      }
    },
    calcHeaderData() {
      let { header } = this.mergedConfig;
      if (!header.length) {
        this.header = [];
        return;
      }
      header = [...header];
      this.header = header;
    },
    calcRowsData() {
      const { index, rowNum } = this.mergedConfig;
      let { data } = this.mergedConfig;
      if (index) {
        data = data.map((row, i) => {
          // eslint-disable-next-line no-param-reassign
          row = Object.values(row);
          row.unshift(i + 1);
          return row;
        });
      }
      // console.log('data', data);
      data = data.map((ceils, i) => ({ ceils: [ceils.uri, ceils.count], rowIndex: i }));
      const rowLength = data.length;
      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [...data, ...data];
      }
      data = data.map((d, i) => ({ ...d, scroll: i }));
      this.rowsData = data;
      this.rows = data;
      // console.log('this.rows', this.rows);
    },
    calcAligns() {
      const columnNum = this.header.length;
      if (this.mergedConfig.align.length) {
        this.aligns = this.mergedConfig.align;
      } else {
        this.aligns = new Array(columnNum).fill('left');
      }
    },
    async animation(start = false) {
      const {
        avgHeight, mergedConfig, rowsData, animation, updater,
      } = this;
      let { animationIndex } = this;
      const { waitTime, carousel, rowNum } = mergedConfig;
      const rowLength = rowsData.length;
      if (rowNum >= rowLength) return;
      if (start) {
        // eslint-disable-next-line no-promise-executor-return
        await new Promise((resolve) => setTimeout(resolve, waitTime));
        if (updater !== this.updater) return;
      }
      const animationNum = carousel === 'single' ? 1 : rowNum;
      const rows = rowsData.slice(animationIndex);
      rows.push(...rowsData.slice(0, animationIndex));
      this.rows = rows;
      this.heights = new Array(rowLength).fill(avgHeight);
      // eslint-disable-next-line no-promise-executor-return
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (updater !== this.updater) return;
      this.heights.splice(0, animationNum, ...new Array(animationNum).fill(0));
      animationIndex += animationNum;
      const back = animationIndex - rowLength;
      if (back >= 0) animationIndex = back;
      this.animationIndex = animationIndex;
      this.animationHandler = setTimeout(animation, waitTime - 300);
    },
    stopAnimation() {
      const { animationHandler, updater } = this;
      this.updater = (updater + 1) % 999999;
      if (!animationHandler) return;
      clearTimeout(animationHandler);
    },
    // emitEvent(ri, ci, row, ceil) {
    //   const { ceils, rowIndex } = row;
    //   this.$emit('click', {
    //     row: ceils,
    //     ceil,
    //     rowIndex,
    //     columnIndex: ci,
    //   });
    // },
  },
};
</script>
<style lang="scss">
.dv-scroll-board {
  position: relative;
  width: 100%;
  height: 100%;
  color: #fff;

  .text {
    padding: 0 10px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .header {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    margin-top: 10px;
    background-image: url("../../../assets/screen-adapter/表头-最近7天供应商排名统计.png");
    background-repeat: no-repeat;
    background-size: cover;
    .header-item {
      font-weight: bold;
      .text {
        padding: 0 10px;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      transition: all 0.3s;
    }
  }
  .rows {
    overflow: hidden;

    .row-item {
      display: flex;
      font-size: 24px;
      transition: all 0.3s;
      background-color: rgba(39, 83, 180, 0.8);
      // background-image: url("../../../assets/screen-adapter/最近7天供应商排名统计条.png");
      // background-repeat: no-repeat;
      // background-size: cover;
      margin-bottom: 8px;
    }
    .card-bg-2 {
      // background-image: url("../../../assets/screen-adapter/统计条2.png");
      background-color: rgba(22, 53, 129, 0.4);
    }
    .ceil {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // .text {
      //   padding: 0 10px;
      //   box-sizing: border-box;
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      // }
    }

    .index {
      border-radius: 3px;
      padding: 0 3px;
    }
  }
}
</style>
